import React, { FC, PropsWithChildren } from 'react'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'

export type CardVariants = 'guild' | 'white' | 'image'

const getVariantClassName = (variant: CardVariants) => {
  switch (variant) {
    case 'guild':
      return 'bg-guild-copper'
    case 'white':
      return 'bg-white border border-core-gray-200'
    case 'image':
      return 'bg-black'
    default:
      return ''
  }
}

interface Props extends PropsWithChildren {
  variant: CardVariants
  backgroundImg?: string | null
  childrenWrapperClassName?: string
  className?: string
  style?: React.CSSProperties
}

export const Card: FC<Props> = ({ children, variant, backgroundImg, childrenWrapperClassName, className, style }) => {
  const CardElement = (
    <div
      style={style}
      className={classNames(
        'relative max-w-[440px] w-full rounded-2xl p-4 overflow-hidden',
        getVariantClassName(variant),
        className,
      )}
    >
      {backgroundImg && (
        <Image
          sizes="(min-width: 768px) 440px, 100vw"
          className="object-cover object-center"
          src={backgroundImg}
          fill
          alt=""
        />
      )}
      {variant === 'image' && <div className="absolute inset-0 bg-black/30" />}
      <div className={classNames('relative z-10 h-full w-full flex flex-col', childrenWrapperClassName)}>
        {children}
      </div>
    </div>
  )

  if (variant === 'guild') {
    return <GuildGradientWrapper>{CardElement}</GuildGradientWrapper>
  }

  return CardElement
}

const GuildGradientWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div
      className="grid w-full max-w-[440px] overflow-hidden rounded-2xl p-[2px]"
      style={{
        backgroundImage:
          'linear-gradient(159.05deg, #EDD7C6 0%, #D6A177 13.88%, #FEDEC6 40.62%, #D48D59 62.21%, #A66141 88.77%, #612B12 98.15%)',
      }}
    >
      {children}
    </div>
  )
}
